import BottomSheet, { BottomSheetModal, BottomSheetView } from "@gorhom/bottom-sheet";
import React, { forwardRef, useMemo, useState, useCallback } from "react";
import { Text } from "@constants/Themed";
import { BlurView } from "@react-native-community/blur";
import styles from "@stylesheet";
import { Progress, Progress as ProgressBar } from 'tamagui';
import { Platform, Pressable, View } from "react-native";
import * as DocumentPicker from 'expo-document-picker';
import * as Animatable from 'react-native-animatable';
import AnimatedLottieView from "@utils/lottieAnimation";
import { Title } from "@constants/Themed";
import { TextInput } from "react-native-gesture-handler";


const UploadHTML = forwardRef((props: any, ref) => {
  const [loading, setLoading] = useState(false);
  const [textActive, setTextActive] = useState(false);
  const [value, setValue] = useState('')


  const _handleItemSelect = useCallback(async (item) => {
    if (props.callback) {
      //TODO add function to ensure that the html is parsed before being sent to the callback function, strip any headers using handlebars


      props.callback(item);
    } else alert('No callback function provided')
  }, [props.callback]);

  const _pickDocument = async () => {
    setLoading(true)
    await DocumentPicker.getDocumentAsync({ type: ['text/html'] })
      .then(result => {
        if (result.canceled || result.assets == null) {
          setLoading(false);
          alert('No file selected')
          return
        };
        _handleItemSelect(result);
        setLoading(false);
        ref.current?.close();
      })
  }

  const snapPoints = useMemo(() => ['80%'], []);
  
  return (
    <BottomSheetModal containerStyle={{ zIndex: 10 }} enablePanDownToClose ref={ref} snapPoints={snapPoints} style={{ marginHorizontal: Platform.select({ default: 5, web: "10%" }), paddingHorizontal: "5%", marginLeft: Platform.select({ web: 400 }), zIndex: 15, maxWidth: Platform.OS === 'web' ? "60%" : undefined, alignSelf: "center", shadowRadius: 20, shadowOpacity: .2 }}>
      {
        loading ?
          <Animatable.View useNativeDriver style={{ position: 'absolute', zIndex: 1, borderRadius: 20 }}>
            <BlurView style={{ flex: 1, justifyContent: 'center', alignItems: 'center', borderRadius: 20, }} blurType={'light'} blurAmount={10} reducedTransparencyFallbackColor={'white'} >
              <View style={{ borderRadius: 20, backgroundColor: 'white', shadowRadius: 20, shadowOpacity: .2 }}>
                <AnimatedLottieView source={require('@assets/animations/leaf_Loader.json')} style={{ width: '100%', height: '100%' }} autoPlay />
                <View style={{ height: 50 }}>
                  <Progress value={0.5} backgroundColor={'rgb(90,192,234)'} style={{ width: '100%' }} />
                </View>
              </View>
            </BlurView>
          </Animatable.View>
          :
          <></>
      }
      <BottomSheetView style={{ padding: 10, gap: 20 }}>
        <View>
          <Title>Upload HTML File</Title>
          <Text style={{ marginVertical: 10 }}>You can upload your own html files from your local device</Text>
          <AnimatedLottieView source={require('@assets/animations/114459-download-file-icon-animation.json')} style={{ width: '100%', height: 150, alignSelf: 'center' }} autoPlay />
          <Pressable onPress={_pickDocument} style={[styles.LoginButton, { flex: 1 }]}>
            <Text adjustsFontSizeToFit >Upload from device</Text>
          </Pressable>
        </View>
        <View >
          <Text style={{ marginVertical: 10 }}>Or paste the code below:</Text>
          <TextInput onChangeText={(value) => setValue(value)} multiline onFocus={() => setTextActive(true)} placeholder={'Paste HTML'} style={{ maxHeight: 300 }} />
          <Pressable onPress={() => { props.callbackFunction(value); ref.current?.close() }} style={[styles.LoginButton, { flex: 1 }]}>
            <Text adjustsFontSizeToFit >Upload from device</Text>
          </Pressable>
        </View>
      </BottomSheetView>
    </BottomSheetModal>
  )
})
export default UploadHTML;